import BaseModelService from '../../base/base_model_service';
import _ from '../../utils/underscore';

class GameServiceModel extends BaseModelService {
    _useDefaults;


    init(params) {

        if (params) {
            this._useDefaults = _.isUndefined(params.useDefaults) ? true : params.useDefaults;
            this._setCashierOpenType(params.cashierOpenType)
                ._setNavbarCustomClientProperties(params.navbar)
                ._setResponsibleGameView(params.responsibleGameView);
        }
    }



    _setResponsibleGameView(responsibleGameView) {
        if (!this._useDefaults && _.isUndefined(responsibleGameView)) {
            return this;
        }

        if (!_.isNumber(responsibleGameView)) {
            return this;
        }

        this._responsibleGameView = responsibleGameView;
        return this;
    }


    _setCashierOpenType(cashierOpenType) {
        if (!this._useDefaults && _.isUndefined(cashierOpenType)) {
            return this;
        }

        if (!_.isNumber(cashierOpenType)) {
            this._cashierOpenType = 0;
            return this;
        }

        this._cashierOpenType = cashierOpenType;
        return this;
    }

    _setNavbarCustomClientProperties(navbarProps) {
        if (!this._useDefaults && _.isUndefined(navbarProps)) {
            return this;
        }

        if (_.isUndefined(navbarProps)) {
            return this;
        }

        this._navbarProps = navbarProps;
        return this;
    }

    getResponsibleGameView() {
        return this._responsibleGameView;
    }

    getNavbarProps() {
        return this._navbarProps;
    }

    getCashierOpenType() {
        return this._cashierOpenType;
    }
}

export default GameServiceModel;